/**
 * DesignSchool Forms - Main Entry Point
 *
 * @package DesignSchool\Forms
 */

// UTM module - must load first to set window.forceUTM (cookie-based)
import './utm';
import { intlUtilsReady } from './phone-utils-bootstrap';

// CSS is now loaded separately via wp_enqueue_style
// import '../css/src/forms.scss';
// import '../css/src/sticky-footer.scss';
// import '../css/src/modal.scss';
// import '../css/src/notification.scss';
import { FormHandler } from './form-handler';
import { PhoneMask } from './phone-mask';
import { dynamicSelects } from './dynamic-selects';
import { stickyFooter } from './sticky-footer';
import { tabSwitcher } from './tab-switcher';
import { modal } from './modal';
import { notification } from './notification';
import { successModal } from './success-modal';

// Declare jQuery
declare var jQuery: any;
declare var dsFormsConfig: any;

(function($) {
    'use strict';

    /**
     * Initialize plugin
     */
    $(document).ready(function() {
        console.log('[DesignSchool Forms] Initializing v' + (dsFormsConfig.version || '1.0.0'));
        
        if (dsFormsConfig.devMode) {
            console.log('[DesignSchool Forms] 🧪 DEV MODE ENABLED');
        }

        void intlUtilsReady.then(() => {
        const phoneMask = new PhoneMask();
        (window as any).dsFormsPhoneMask = phoneMask;

        const formHandler = new FormHandler();
        formHandler.init();

        phoneMask.init();

        (window as any).dsFormsHandler = formHandler;
        (window as any).dsFormsDynamicSelects = dynamicSelects;
        (window as any).dsFormsStickyFooter = stickyFooter;
        (window as any).dsFormsTabSwitcher = tabSwitcher;
        (window as any).dsFormsModal = modal;
        (window as any).dsFormsNotification = notification;
        (window as any).dsFormsSuccessModal = successModal;
        });
    });

})(jQuery);

